import Vue from 'vue'
import axios from 'axios'
import { HTTP } from '@/utils/http-common'
import VueCookies from 'vue-cookies'

export default {
    getDatasetList (parent) {
        const route = parent.$route.params.project ? `/projects/manage/${parent.$route.params.project}/dataset/` : '/datastore/dataset/manage/'
        return HTTP.get(route)
    },
    getSource (type, dataset) {
        if (type === 'dataset') { return HTTP.get('/datastore/dataset/manage/' + dataset.hmd_id + '/') } else if (type === 'api') { return HTTP.get('/gateway/api/manage/' + dataset.hmd_id + '/') }
    },
    getApiList (parent) {
        return HTTP.get(`/projects/manage/${parent.$route.params.project}/api/`)
    },
    getFunctionList (parent) {
        return HTTP.get(`/projects/manage/${parent.$route.params.project}/function/`)
    },
    createTrigger (trigger, parent) {
        trigger.project_id = parent.$route.params.project
        HTTP.post('triggers/' + trigger.type + '/manage/', trigger).then(function (response) {
            parent.$store.commit('push', { msg: 'Trigger created', color: 'success' })
        }).catch(function (error) {
            parent.$store.commit('push', { msg: 'This trigger (or an almost identical one) has already been created', color: 'error' })
        })
    },
    deleteTrigger (trigger, parent, isNew) {
        HTTP.delete('/triggers/' + trigger.type + '/manage/' + trigger.id + '/').then(function (response) {
            parent.$store.commit('push', { msg: 'Trigger deleted', color: 'success' })
            parent.$emit('deleteTrigger', { id: trigger.id, type: trigger.type })
        }).catch(function (error) {
            parent.$store.commit('push', { msg: 'Error when deleting the trigger', color: 'error' })
        })
    },
    updateTrigger (trigger) {
        HTTP.put('/triggers/' + trigger.type + '/manage/' + trigger.id + '/', {
            enabled: trigger.enabled,
        }).then(function (response) {}).catch(function (error) {})
    },
    getTrigger (type, id) {
        return HTTP.get('/triggers/' + type + '/manage/' + id + '/')
    },
    getTriggerList (type) {
        return HTTP.get('triggers/' + type + '/manage/')
    },
    resyncTrigger (trigger, parent) {
        HTTP.get(`/triggers/${trigger.type}/resync/${trigger.id}/`).then(function (response) {
            parent.$store.commit('push', { msg: 'Trigger resynchronized', color: 'success' })
        }).catch(function (error) {
            parent.$store.commit('push', { msg: 'Error when resynchronizing the trigger', color: 'error' })
        })
    },
}
